import React from 'react';

import { Box, Typography } from '@mui/material';

import { SmallInlineLoadingSpinner } from '@components/spinners/SmallInlineLoadingSpinner';

import type { ComponentLoadingFallbackProperties } from './ComponentLoadingFallback.types';

export const ComponentLoadingFallback: React.FC<
  ComponentLoadingFallbackProperties
> = ({
  message = 'Подготовка компонента...',
  size = '15',
  minHeight = '40px',
  dataTest = 'component_loading_fallback',
}) => {
  return (
    <Box
      data-testid={dataTest}
      sx={{
        width: '100%',
        minHeight: minHeight,
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'start',
        gap: 2
      }}>
      <SmallInlineLoadingSpinner size={size} isLoading />
      <Typography variant='body2' sx={{
        color: 'text.secondary'
      }}>
        {message}
      </Typography>
    </Box>
  );
};
